import { render } from "./CIS-Home-Industry.vue?vue&type=template&id=31b9407a&scoped=true"
import script from "./CIS-Home-Industry.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Industry.vue?vue&type=script&lang=js"

import "./CIS-Home-Industry.vue?vue&type=style&index=0&id=31b9407a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b9407a"]])

export default __exports__